import api from 'api';

const url = 'api/events';

export default {
    fetch: (params) => api.get({path: url, params: {...params, passed: 0}})
}